(function(){
  function fireConfetti() {
    if (typeof confetti !== 'function') return;
    var defaults = { origin: { y: 0.3 } };
    function fire(particleRatio, opts) {
      confetti(Object.assign({}, defaults, opts, { particleCount: Math.floor(200 * particleRatio) }));
    }
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });
  }

  function applyPrimaryToDemo(){
    try {
      var container = document.getElementById('payment-completed-page');
      if (!container) return;
      var btn = container.querySelector('.btn-primary');
      var color = btn ? getComputedStyle(btn).backgroundColor : '#0d6efd';
      var rgb = parseColor(color) || {r:13,g:110,b:253};
      var dark = shade(rgb, -0.12);
      var darker = shade(rgb, -0.24);
      var root = container;
      root.style.setProperty('--primary', toCss(rgb));
      root.style.setProperty('--primary-dark', toCss(dark));
      root.style.setProperty('--primary-darker', toCss(darker));
      root.style.setProperty('--primary-18', toRgba(rgb, 0.18));
      root.style.setProperty('--primary-20', toRgba(rgb, 0.20));
      root.style.setProperty('--primary-45', toRgba(rgb, 0.45));
    } catch(e) { /* no-op */ }
  }

  function parseColor(str){
    if (!str) return null;
    var m = str.match(/^rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (m) return { r: +m[1], g: +m[2], b: +m[3] };
    var hx = str.trim();
    if (/^#([0-9a-f]{3})$/i.test(hx)) {
      var h = hx.slice(1);
      return { r: parseInt(h[0]+h[0],16), g: parseInt(h[1]+h[1],16), b: parseInt(h[2]+h[2],16) };
    }
    if (/^#([0-9a-f]{6})$/i.test(hx)) {
      return { r: parseInt(hx.substr(1,2),16), g: parseInt(hx.substr(3,2),16), b: parseInt(hx.substr(5,2),16) };
    }
    return null;
  }
  function rgbToHsl(o){
    var r=o.r/255,g=o.g/255,b=o.b/255;
    var max=Math.max(r,g,b), min=Math.min(r,g,b);
    var h,s,l=(max+min)/2;
    if(max===min){ h=s=0; }
    else {
      var d=max-min;
      s= l>0.5 ? d/(2-max-min) : d/(max+min);
      switch(max){
        case r: h=((g-b)/d + (g<b?6:0)); break;
        case g: h=((b-r)/d + 2); break;
        case b: h=((r-g)/d + 4); break;
      }
      h/=6;
    }
    return {h:h, s:s, l:l};
  }
  function hslToRgb(hsl){
    var h=hsl.h, s=hsl.s, l=hsl.l;
    var r,g,b;
    if(s===0){ r=g=b=l; }
    else {
      function hue2rgb(p,q,t){ if(t<0) t+=1; if(t>1) t-=1; if(t<1/6) return p+(q-p)*6*t; if(t<1/2) return q; if(t<2/3) return p+(q-p)*(2/3 - t)*6; return p; }
      var q = l < 0.5 ? l*(1+s) : l + s - l*s;
      var p = 2*l - q;
      r = hue2rgb(p,q,h + 1/3);
      g = hue2rgb(p,q,h);
      b = hue2rgb(p,q,h - 1/3);
    }
    return { r: Math.round(r*255), g: Math.round(g*255), b: Math.round(b*255) };
  }
  function shade(rgb, percent){
    var hsl = rgbToHsl(rgb);
    hsl.l = Math.max(0, Math.min(1, hsl.l + percent));
    return hslToRgb(hsl);
  }
  function toCss(rgb){ return 'rgb(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ')'; }
  function toRgba(rgb, a){ return 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + a + ')'; }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(fireConfetti, 200); applyPrimaryToDemo(); });
  } else {
    setTimeout(fireConfetti, 200);
    applyPrimaryToDemo();
  }
})();
